import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useNuxtApp } from "nuxt/app";
const makeMainMenu = (items) => {
  let menu = items;
  menu.sort((i1, i2) => i1.index - i2.index);
  const homepageMenu = menu.find((m) => m.path === "homepage");
  if (homepageMenu) {
    homepageMenu.path = "";
  }
  const unfilteredMenu = [...menu];
  menu = menu.filter((i) => !i.isHidden);
  return [menu, unfilteredMenu];
};
const bfs = (menu) => {
  const menus = [];
  const queue = menu;
  while (queue.length) {
    const cur = queue.pop();
    if (!cur) {
      continue;
    }
    menus.push(cur);
    cur.children.forEach((child) => queue.unshift(child));
  }
  return menus;
};
export const cmsContentStore = defineStore("cmsContent", () => {
  const { $api } = useNuxtApp();
  const page = ref({
    page: {
      id: 0,
      titleTag: "",
      navId: 0,
      langId: 0,
      keywords: "",
      title: "",
      description: "",
      alias: ""
    },
    properties: {
      announce: "",
      date: ""
    },
    layout: {
      id: 0,
      name: ""
    },
    placeholders: {
      content: []
    }
  });
  const loading = ref({
    page: false,
    menu: false
  });
  const error = ref(null);
  const menu = ref([]);
  const menus = ref({});
  const flatMenu = ref([]);
  const setPage = (pageOptions) => {
    page.value = pageOptions;
  };
  const getMenu = async () => {
    try {
      loading.value.menu = true;
      const resMenus = await $api.cmsContentApi.getContentMenus();
      menus.value = resMenus;
      if (resMenus) {
        flatMenu.value = Object.entries(resMenus).flatMap(([key]) => bfs([...resMenus[key].items]));
      }
      if (resMenus && resMenus?.default) {
        const [newMenu] = makeMainMenu(resMenus?.default.items);
        menu.value = newMenu;
      }
      return resMenus;
    } catch (ex) {
      throw ex;
    } finally {
      loading.value.menu = false;
    }
  };
  const getPageById = async (id) => {
    try {
      loading.value.page = true;
      return await $api.cmsContentApi.getContentPageById(id);
    } catch (ex) {
      throw ex;
    } finally {
      loading.value.page = false;
    }
  };
  const getPage = async ({ pageIdOrName, contentOnly = false }) => {
    try {
      let contentCmsRes;
      loading.value.page = true;
      if (Number.isInteger(pageIdOrName)) {
        contentCmsRes = await $api.cmsContentApi.getContentPageById(pageIdOrName);
      }
      if (typeof pageIdOrName === "string") {
        contentCmsRes = await $api.cmsContentApi.getContentPage(pageIdOrName);
      }
      if (contentOnly) {
        return contentCmsRes;
      }
      page.value = contentCmsRes;
      return contentCmsRes;
    } catch (ex) {
      throw ex;
    } finally {
      loading.value.page = false;
    }
  };
  const flatMenuList = computed(() => flatMenu.value);
  const menuList = computed(() => menu.value || []);
  return {
    page,
    loading,
    error,
    menu,
    menus,
    flatMenu,
    setPage,
    getMenu,
    getPageById,
    getPage,
    flatMenuList,
    menuList
  };
});
